export default {
    "fe__header__title": {
        "sl": "Rezervacije - Soča Adventure",
        "en": "Reservations - Soča Adventure",
        "de": "Reservierungen - Soča Adventure"
    },
    "fe__header__subtitle": {
        "sl": "Preveri razpoložljivost v športnem centru Soča Adventure",
        "en": "Check availability at the Soča Adventure sports center",
        "de": "Überprüfen Sie die Verfügbarkeit im Sportzentrum Soča Adventure"
    },
    "fe__header__subsubtitle": {
        "sl": "Izberite željeni datum aktivnosti in število oseb",
        "en": "Select the desired activity date and number of people",
        "de": "Wählen Sie das gewünschte Aktivitätsdatum und die Anzahl der Personen"
    },
    "fe__main_selector__accommodation_type": {
        "sl": "Aktivnost",
        "en": "Activity",
        "de": "Aktivität"
    },
    "fe__main_selector__person_count": {
        "sl": "Število oseb",
        "en": "Number of people",
        "de": "Anzahl der Personen"
    },
    "fe__main_selector__person_adult": {
        "sl": "Odrasli",
        "en": "Adults",
        "de": "Erwachsene"
    },
    "fe__main_selector__person_child_2": {
        "sl": "",
        "en": "",
        "de": ""
    },
    "fe__main_selector__person_child_1": {
        "sl": "Otroci (0-18)",
        "en": "Children (0-18)",
        "de": "Kinder (0-18)"
    },
    "fe__main_selector__date_range": {
        "sl": "Datum",
        "en": "Date",
        "de": "Datum"
    },
    "fe__main_selector__date_range_empty": {
        "sl": "Izberite datum",
        "en": "Select date",
        "de": "Datum wählen"
    },
    "fe__main_selector__child_ages": {
        "sl": "Starost otrok",
        "en": "Age of children",
        "de": "Alter der Kinder"
    },
    "fe__main_selector__child_age": {
        "sl": ". otrok",
        "en": ". child",
        "de": ". Kind"
    },
    "fe__bottom_bar__current_selection": {
        "sl": "Trenutni izbor",
        "en": "Current selection",
        "de": "Aktuelle Auswahl"
    },
    "fe__bottom_bar__cart__person_count": {
        "sl": "Število oseb:",
        "en": "Number of people:",
        "de": "Anzahl der Personen:"
    },
    "fe__bottom_bar__continue": {
        "sl": "NAPREJ",
        "en": "NEXT",
        "de": "WEITER"
    },
    "fe__bottom_bar__continue_index_text": {
        "sl": "Dodajte aktivnost oz. pritisnite NAPREJ za nadaljevanje",
        "en": "Add activity or press NEXT to continue",
        "de": "Aktivität hinzufügen oder WEITER drücken, um fortzufahren"
    },
    "fe__overview__title": {
        "sl": "POVZETEK REZERVACIJE",
        "en": "RESERVATION SUMMARY",
        "de": "RESERVIERUNGSÜBERSICHT"
    },
    "fe__overview__intro": {
        "sl": "Potrditev rezervacije boste prejeli na e-poštni naslov, ki ga boste navedli spodaj pri podatkih o nosilcu rezervacije.",
        "en": "You will receive a confirmation of your reservation to the email address you provide below in the reservation holder information.",
        "de": "Sie erhalten eine Bestätigung Ihrer Reservierung an die E-Mail-Adresse, die Sie unten in den Reservierungsinhaberinformationen angeben."
    },
    "fe__overview__table__service": {
        "sl": "Storitev",
        "en": "Service",
        "de": "Service"
    },
    "fe__overview__table__date_range": {
        "sl": "Datum in ura",
        "en": "Date and time",
        "de": "Datum und Zeit"
    },
    "fe__overview__table__day_count": {
        "sl": "",
        "en": "",
        "de": ""
    },
    "fe__overview__table__quantity": {
        "sl": "Kol.",
        "en": "Qty",
        "de": "Menge"
    },
    "fe__overview__table__price_item": {
        "sl": "Cena",
        "en": "Price",
        "de": "Preis"
    },
    "fe__overview__table__price": {
        "sl": "Znesek",
        "en": "Amount",
        "de": "Betrag"
    },
    "fe__overview__table__total": {
        "sl": "Znesek rezervacije",
        "en": "Reservation Amount",
        "de": "Reservierungsbetrag"
    },
    "fe__overview__table__person_adult": {
        "sl": "Odrasli",
        "en": "Adults",
        "de": "Erwachsene"
    },
    "fe__overview__table__person_child_2": {
        "sl": "Mladostniki (15-18)",
        "en": "Youth (15-18)",
        "de": "Jugendlicher (15-18)"
    },
    "fe__overview__table__person_child_1": {
        "sl": "Otroci (do {age} let)",
        "en": "Children (up to {age} years)",
        "de": "Kinder (bis {age} Jahre)"
    },
    "fe__overview__table__days": {
        "sl": "dan\/dni",
        "en": "day\/days",
        "de": "tag\/tage"
    },
    "fe__overview__table__surcharge_d1": {
        "sl": "",
        "en": "",
        "de": ""
    },
    "fe__overview__table__surcharge_d2": {
        "sl": "",
        "en": "",
        "de": ""
    },
    "fe__overview__tourist_tax": {
        "sl": "Dovolilnica za plovbo za rafting in kajak spust ni vključena v ceno rezervacije.",
        "en": "River permit for rafting and kayaking is not included in the reservation price.",
        "de": "Eine Flussgenehmigung fur rafting und kajakfahren ist nicht im Reservierungspreis enthalten."
    },
    "fe__overview__prepayment_title": {
        "sl": "",
        "en": "",
        "de": ""
    },
    "fe__overview__prepayment_description": {
        "sl": "",
        "en": "",
        "de": ""
    },
    "fe__overview__meeting_location__title": {
        "sl": "Zbirno mesto",
        "en": "Meeting point",
        "de": "Treffpunkt"
    },
    "fe__overview__meeting_location__location_1": {
        "sl": "Zbirno mesto je v naši bazi: <strong>Industrijska cona 4, 5230 Bovec</strong>",
        "en": "The meeting point is at our base: <strong>Industrijska cona 4, 5230 Bovec</strong>",
        "de": "Treffpunkt ist bei unserer Basis: <strong>Industrijska cona 4, 5230 Bovec</strong>"
    },
    "fe__overview__meeting_location__location_2": {
        "sl": "Prosimo, izberite to možnost, če želite prevzem v naši pisarni v Bovcu: <strong>Ledina 5, 5230 Bovec</strong>",
        "en": "Please select this option if you would like to be picked up at our office in Bovec: <strong>Ledina 5, 5230 Bovec</strong>",
        "de": "Bitte wählen Sie diese Option, wenn Sie von unserem Büro in Bovec abgeholt werden möchten: <strong>Ledina 5, 5230 Bovec</strong> vorhanden"
    },
    "fe__overview__customer__title": {
        "sl": "Podatki o nosilcu rezervacije",
        "en": "Booking information",
        "de": "Buchungsinformation"
    },
    "fe__overview__customer__name": {
        "sl": "Ime",
        "en": "Name",
        "de": "Name"
    },
    "fe__overview__customer__surname": {
        "sl": "Priimek",
        "en": "Surname",
        "de": "Nachname"
    },
    "fe__overview__customer__email": {
        "sl": "E-naslov",
        "en": "E-mail",
        "de": "E-mail"
    },
    "fe__overview__customer__email_again": {
        "sl": "Ponovi e-naslov",
        "en": "Confirm E-mail",
        "de": "E-Mail bestätigen"
    },
    "fe__overview__customer__country": {
        "sl": "Država",
        "en": "Country",
        "de": "Land"
    },
    "fe__overview__customer__phone": {
        "sl": "Telefonska številka",
        "en": "Phone Number",
        "de": "Telefonnummer"
    },
    "fe__overview__customer__address": {
        "sl": "Naslov",
        "en": "Address",
        "de": "Adresse"
    },
    "fe__overview__customer__post_office": {
        "sl": "Poštna številka in pošta",
        "en": "Post Code and post",
        "de": "Postleitzahl und Postamt"
    },
    "fe__overview__customer__note": {
        "sl": "Vaše sporočilo\n<br \/>\n<em>Vnesite opombo oz. komentar glede vaše rezervacije<\/em>",
        "en": "Your message\n<br \/>\n<em>Enter a note or a comment about your reservation<\/em>",
        "de": "Ihre Nachricht\n<br \/>\n<em>Geben Sie eine Notiz ein oder einen Kommentar zu Ihrer Reservierung<\/em>"
    },
    "fe__overview__customer__agree_1": {
        "sl": "Z oddajo rezervacije sprejemam pogoje poslovanja, ki so na voljo na spletni strani <a href='https:\/\/www.soca-adventure.com\/' target='_blank'>https:\/\/www.soca-adventure.com\/<\/a>",
        "en": "By submitting the reservation, I accept the terms and conditions available on the website <a href='https:\/\/www.soca-adventure.com\/' target='_blank'>https:\/\/www.soca-adventure.com\/<\/a>",
        "de": "Mit dem Absenden einer Reservierung akzeptiere ich die auf der Website <a href='https:\/\/www.soca-adventure.com\/' target='_blank'>https:\/\/www.soca-adventure.com\/<\/a> verfügbaren Geschäftsbedingungen."
    },
    "fe__overview__customer__agree_2": {
        "sl": "Strinjam se, da se moje kontaktne informacije hranijo in uporabljajo za obveščanje o novicah in drugih informacijah po e-pošti\/telefonu",
        "en": "I agree that my contact information is being stored and used to inform me about news and other information via e-mail\/phone.",
        "de": "Ich bin damit einverstanden, dass meine Kontaktinformationen gespeichert und verwendet werden, um mich per E-Mail\/Telefon über Neuigkeiten und andere Informationen zu informieren."
    },
    "fe__bottom_bar__back": {
        "sl": "NAZAJ NA IZBOR",
        "en": "BACK TO SELECTION",
        "de": "ZURUCK ZU AUSWAHL"
    },
    "fe__bottom_bar__confirm": {
        "sl": "POTRDI REZERVACIJO",
        "en": "CONFIRM RESERVATION",
        "de": "RESERVIERUNG BESTÄTIGEN"
    },
    "fe__success_dialog__title": {
        "sl": "<strong>Vaša rezervacija je bila uspešno oddana.</strong><br /><br />Na e-mail naslov, ki ste ga posredovali, smo vam poslali povzetek rezervacije.",
        "en": "<strong>Your reservation was successfully submitted.</strong><br /><br />We have sent a Reservation summary to the email address you provided.",
        "de": "<strong>Ihre Reservierung wurde erfolgreich übermittelt.</strong><br /><br />Wir haben eine Reservierungsübersicht an die von Ihnen angegebene E-Mail-Adresse gesendet."
    },
    "fe__success_dialog__close": {
        "sl": "ZAPRI",
        "en": "CLOSE",
        "de": "SCHLIESSEN"
    },
    "fe__error_dialog__title": {
        "sl": "Opozorilo",
        "en": "Warning",
        "de": "Warnung"
    },
    "fe__error_dialog__validation_messages__empty_cart": {
        "sl": "Izbrati je potrebno vsaj eno rezervacijo!",
        "en": "You must select at least one reservation!",
        "de": "Sie müssen mindestens eine Reservierung auswählen!"
    },
    "fe__error_dialog__validation_messages__required_fields": {
        "sl": "Podatki o nosilcu rezervacije - Vsa polja morajo biti izpolnjena!",
        "en": "Booking information - All fields must be filled in!",
        "de": "Buchungsinformation - Alle Felder müssen ausgefüllt werden!"
    },
    "fe__error_dialog__validation_messages__invalid_email": {
        "sl": "Neveljaven e-naslov!",
        "en": "Invalid e-mail address!",
        "de": "Ungültige E-Mail-Adresse!"
    },
    "fe__error_dialog__validation_messages__emails_not_match": {
        "sl": "E-naslova se ne ujemata!",
        "en": "E-mail addresses do not match!",
        "de": "E-Mail-Adressen stimmen nicht überein!"
    },
    "fe__error_dialog__error_from_server": {
        "sl": "Napaka pri shranjevanju",
        "en": "Error while saving",
        "de": "Fehler beim Speichern"
    },
    "fe__error_dialog__occupied": {
        "sl": "Spodaj navedene rezervacije trenutno niso možne.<br \/>{reservations}<br \/><br \/>Prosimo poizkusite ponovno in po potrebi spremenite pogoje iskanja.",
        "en": "The reservations listed below are currently not possible.<br \/>{reservations}<br \/><br \/>Please try again and change the search conditions if necessary.",
        "de": "Die unten aufgeführten Reservierungen sind derzeit nicht möglich.<br \/>{reservations}<br \/><br \/>Bitte versuchen Sie es erneut und ändern Sie gegebenenfalls die Suchbedingungen."
    },
    "fe__error_dialog__close": {
        "sl": "ZAPRI",
        "en": "CLOSE",
        "de": "SCHLIESSEN"
    },
    "fe__accommodation_type__room": {
        "sl": "",
        "en": "",
        "de": ""
    },
    "fe__accommodation_room__show_more": {
        "sl": "Prikaži več",
        "en": "Show more",
        "de": "Zeig mehr"
    },
    "fe__accommodation_room__show_less": {
        "sl": "Prikaži manj",
        "en": "Show less",
        "de": "Zeige weniger"
    },
    "fe__accommodation_room__per_children": {
        "sl": " \/ otroci",
        "en": "\/ children",
        "de": "\/ Kinder"
    },
    "fe__accommodation_room__per_adults": {
        "sl": " \/ odrasli",
        "en": "\/ adults",
        "de": "\/ Erwachsene"
    },
    "fe__accommodation_room__per_group": {
        "sl": " \/ skupina",
        "en": "\/ group",
        "de": "\/ Gruppe"
    },
    "fe__accommodation_room__select_time_slot": {
        "sl": "Izberi uro odhoda",
        "en": "Select departure time",
        "de": "Abfahrtszeit auswählen"
    },
    "fe__accommodation_item__choose": {
        "sl": "IZBERI",
        "en": "CHOOSE",
        "de": "WÄHLEN"
    },
    "fe__accommodation_item__occupied": {
        "sl": "NI NA VOLJO",
        "en": "UNAVAILABLE",
        "de": "NICHT VERFÜGBAR"
    },
    "fe__accommodation_item__unavailable_time_limit": {
        "sl": "Rezervacija ni možna manj kot {time_limit} h pred odhodom",
        "en": "Reservations are not possible less than {time_limit} h before departure.",
        "de": "Reservierungen sind weniger als {time_limit} h vor Abflug nicht möglich."
    },
    "fe__accommodation_item__unavailable_extended": {
        "sl": "Če želite biti obveščeni v kolikor bo rezervacija za željeni termin/uro vseeno možna, prosimo pošljite povpraševanje na <a href=\"mailto:info@soca-adventure.com\">info@soca-adventure.com</a>",
        "en": "If you would like to be informed if a reservation for the desired date/time is still possible, please send an inquiry to <a href=\"mailto:info@soca-adventure.com\">info@soca-adventure.com</a>",
        "de": "Wenn Sie darüber informiert werden möchten, ob eine Reservierung für das gewünschte Datum/die gewünschte Uhrzeit noch möglich ist, senden Sie bitte eine Anfrage an <a href=\"mailto:info@soca-adventure.com\">info@soca-adventure.com</a>"
    },
    "fe__accommodation_item__count_not_in_range_min": {
        "sl": "Minimalno število oseb: {min_person}",
        "en": "Minimum number of people: {min_person}",
        "de": "Mindestteilnehmerzahl: {min_person}"
    },
    "fe__accommodation_item__count_not_in_range_max": {
        "sl": "Maksimalno število oseb: {max_person}",
        "en": "Maximum number of people: {max_person}",
        "de": "Maximale Personenzahl: {max_person}"
    },
    "fe__accommodation_item__in_cart": {
        "sl": "TRENUTNO IZBRANO",
        "en": "CURRENTLY SELECTED",
        "de": "MOMENTAN AUSGEWÄHLT"
    },
    "fe__accommodation_item__invalid_children_ages": {
        "sl": "Prosimo, vnesite starosti vseh otrok",
        "en": "Please enter the ages of all children",
        "de": "Bitte geben Sie das Alter aller Kinder ein"
    },
    "fe__accommodation_item__min_child_age": {
        "sl": "Minimalna starost: {age} let(a)",
        "en": "Minimum age: {age} years",
        "de": "Mindestalter: {age} Jahre"
    },
    "fe__accommodation_details_dialog__title": {
        "sl": "Potrebujemo še nekaj informacij, da vam lahko ponudimo najprimernejšo storitev.",
        "en": "We need some more information so we can offer you the most appropriate service.",
        "de": "Um Ihnen den passenden Service anbieten zu können, benötigen wir noch einige weitere Informationen."
    },
    "fe__accommodation_details_dialog__additional_services__title": {
        "sl": "",
        "en": "",
        "de": ""
    },
    "fe__accommodation_details_dialog__cancel": {
        "sl": "Prekliči",
        "en": "Cancel",
        "de": "Absagen"
    },
    "fe__accommodation_details_dialog__continue": {
        "sl": "Nadaljuj",
        "en": "Continue",
        "de": "Weitermachen"
    },
    "fe__accommodation_details_dialog__email_inquiry__button_title": {
        "sl": "POVPRAŠEVANJE",
        "en": "INQUIRY",
        "de": "ANFRAGE"
    },
    "fe__accommodation_details_dialog__email_inquiry__button_description": {
        "sl": "Prosim pošljite povpraševanje na<br /><a href=\"mailto:info@soca-adventure.com\">info@soca-adventure.com</a>",
        "en": "Please send an inquiry to<br /><a href=\"mailto:info@soca-adventure.com\">info@soca-adventure.com</a>",
        "de": "Bitte senden Sie eine Anfrage an<br /><a href=\"mailto:info@soca-adventure.com\">info@soca-adventure.com</a>"
    },
    "fe__accommodation_details_dialog__email_inquiry__subject": {
        "sl": "Povpraševanje – dolgi rafting",
        "en": "Inquiry - Long Rafting",
        "de": "Anfrage - Long Rafting"
    },
    "fe__accommodation_details_dialog__email_inquiry__body": {
        "sl": "Datum: {date}\n\nŠtevilo oseb: Odrasli: {adult_count} | Otroci (0-18): {child_count}\n\n",
        "en": "Date: {date}\n\nNumber of people: Adults: {adult_count} | Children (0-18): {child_count}\n\n",
        "de": "Datum: {date}\n\nAnzahl der Personen: Erwachsene: {adult_count} | Kinder (0-18): {child_count}\n\n"
    }
};
